const SiteUnite = () => import("../Views/SiteUnite.vue");

export default [
    {
        path: "/SiteUnite",
        name: "Site Unite",
        component: SiteUnite,
        meta: { requiresAuth: true, checkPermissions: true, module: "site_unite", title: "CruzControl | Site Unite" }
    },
    {
        path: "/SiteUnite/internet",
        name: "internet",
        component: SiteUnite,
        meta: { requiresAuth: true, checkPermissions: true, module: "site_unite", feature: "internet", title: "CruzControl | Internet" }
    },
    {
        path: "/SiteUnite/network_devices",
        name: "network_devices",
        component: SiteUnite,
        meta: { requiresAuth: true, checkPermissions: true, module: "site_unite", feature: "network_devices", title: "CruzControl | Devices" }
    },
]